export type HighlightCategory = "action" | "passive";
export type HighlightAction = "resend_invite" | "nudge_client" | "nudge_estate_account" | null;

export interface HighlightData {
  category: HighlightCategory;
  action: HighlightAction;
  label: string;
  nextStep: string;
  timeAgo: string;
  timestamp: string;
}

export interface LawyerEstateRow {
  id: string;
  estateId: number;
  assignedAt: string | null;
  clientName: string | null;
  clientEmail: string | null;
  clientRole: string | null;
  clientRelationship: string | null;
  decedentName: string | null;
  dateOfDeath: string | null;
  proceedingType: string;
  authoritySuffix: string;
  highlight: HighlightData | null;
  pendingInvitationId?: number;
  inventoryTotal: number;
  assetCount: number;
  liabilityCount: number;
  location: string | null;
}

export interface DashboardFilters {
  proceeding: string[];
  authority: string[];
  inventorySize: string | null;
  nextStep: string[];
  state: string | null;
  lastUpdated: string | null;
}

export const EMPTY_FILTERS: DashboardFilters = {
  proceeding: [],
  authority: [],
  inventorySize: null,
  nextStep: [],
  state: null,
  lastUpdated: null,
};

export interface UserEstateRow {
  estate_id: number | null;
  user_id: number | null;
  is_executor: boolean;
  is_administrator: boolean;
  is_trustee: boolean;
  is_nominated: boolean;
  relationship_to_decedent: string | null;
}

export interface UserRow {
  user_id: number;
  full_name: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
}

export interface EstateItemRow {
  estate_id: number;
  classification: string;
  balance: number;
}

export interface EstateInvitationRow {
  estate_id: number;
  status: string;
  created_at: string;
}

export interface EstateContactRow {
  estate_id: number | null;
  relationship: string | null;
  email: string | null;
  phone: string | null;
}

export interface ActivityLogRow {
  estate_id: number;
  action_type: string;
  metadata: Record<string, unknown> | null;
  created_at: string;
}
